export default __webpack_public_path__ + "images/e7368722a0654965dd0d66ad6cb5844b.png";